<template>
  <div class="page_wrapper container-fluid campus_recruiting_area">
    <div class="row page_header campus_recruiting_header">
      <campus-recruiting-header />
    </div>
    <div class="row campus_recruiting_content">
      <enterprise-print-advertising-details-content />
    </div>
  </div>
</template>
<script>
import CampusRecruitingHeader from '~components/pages/campus-recruiting/common/CampusRecruitingHeader'
import EnterprisePrintAdvertisingDetailsContent from '~components/pages/campus-recruiting/enterprise/EnterprisePrintAdvertisingDetailsContent'
export default {
  name: 'EnterpriseAdvertisingDetails',
  middleware: ['check-auth', 'enterprise-auth'],
  routerName: 'Campus-recruiting:idEnterprisePrint-advertising',
  components: {
    CampusRecruitingHeader,
    EnterprisePrintAdvertisingDetailsContent
  }
}
</script>
